export default class parkData {
  get() {
    return [
      {
        id: 74271,
        abbreviation: "acad",
        agencyName: "National Park Service",
        name: "Acadia National Park",
        mapx: 994,
        mapy: 71
      },
      {
        id: 74296,
        abbreviation: "yose",
        agencyName: "National Park Service",
        name: "Yosemite National Park",
        mapx: 218,
        mapy: 224
      },
      {
        id: 74278,
        abbreviation: "ever",
        agencyName: "National Park Service",
        name: "Everglades National Park",
        mapx: 877,
        mapy: 498
      },
      {
        id: 72448,
        abbreviation: "colm",
        agencyName: "National Park Service",
        name: "Colorado National Monument",
        mapx: 394,
        mapy: 232
      },
      {
        id: 74280,
        abbreviation: "glac",
        agencyName: "National Park Service",
        name: "Glacier National Park",
        mapx: 345,
        mapy: 20
      },
      {
        id: 72471,
        abbreviation: "seki",
        agencyName: "National Park Service",
        name: "Sequoia and Kings Canyon National Parks",
        mapx: 227,
        mapy: 247
      },
      {
        id: 74282,
        abbreviation: "grca",
        agencyName: "National Park Service",
        name: "Grand Canyon National Park",
        mapx: 333,
        mapy: 288
      },
      {
        id: 2620,
        abbreviation: "casa",
        agencyName: "National Park Service",
        name: "Castillo de San Marcos National Monument",
        mapx: 849,
        mapy: 398
      },
      {
        id: 72451,
        abbreviation: "yell",
        agencyName: "National Park Service",
        name: "Yellowstone National Park",
        mapx: 384,
        mapy: 111
      },
      {
        id: 72477,
        abbreviation: "thro",
        agencyName: "National Park Service",
        name: "Theodore Roosevelt National Park",
        mapx: 488,
        mapy: 66
      },
      {
        id: 74289,
        abbreviation: "mora",
        agencyName: "National Park Service",
        name: "Mount Rainier National Park",
        mapx: 230,
        mapy: 25
      },
      {
        id: 74295,
        abbreviation: "whis",
        agencyName: "National Park Service",
        name: "Whiskeytown National Recreation Area",
        mapx: 194,
        mapy: 153
      },
      {
        id: 74290,
        abbreviation: "olym",
        agencyName: "National Park Service",
        name: "Olympic National Park",
        mapx: 212,
        mapy: 5
      },
      {
        id: 70202,
        abbreviation: "havasu",
        agencyName: "Bureau of Land Management",
        name: "Lake Havasu Shoreline Sites",
        mapx: 294,
        mapy: 310
      },
      {
        id: 74405,
        abbreviation: "uwc",
        agencyName: "National Forest Service",
        name: "Uinta-Wasatch-Cache National Forest",
        mapx: 360,
        mapy: 190
      },
      {
        id: 2647,
        abbreviation: "crla",
        agencyName: "National Park Service",
        name: "Crater Lake National Park",
        mapx: 205,
        mapy: 100
      },
      {
        id: 74453,
        abbreviation: "wayne",
        agencyName: "National Forest Service",
        name: "Wayne National Forest",
        mapx: 807,
        mapy: 233
      },
      {
        id: 2708,
        abbreviation: "fova",
        agencyName: "National Park Service",
        name: "Fort Vancouver National Historic Site",
        mapx: 215,
        mapy: 45
      },
      {
        id: 2604,
        abbreviation: "cabr",
        agencyName: "National Park Service",
        name: "Cabrillo National Monument",
        mapx: 235,
        mapy: 320
      },
      {
        id: 72635,
        abbreviation: "crgnsa",
        agencyName: "National Forest Service",
        name: "Columbia River Gorge National Scenic Area",
        mapx: 230,
        mapy: 50
      },
      {
        id: "eb34b293-bd2b-4120-b6fa-c18be8184a67",
        abbreviation: "yuma",
        agencyName: "Bureau of Land Management",
        name: "Yuma Field Office BLM",
        mapx: 285,
        mapy: 345
      },
      {
        id: "eureka",
        abbreviation: "eureka",
        agencyName: "INA",
        name: "Eureka Springs Historic Tram Tours",
        mapx: 635,
        mapy: 295,
        state: true
      },
      {
        id: "trolley",
        abbreviation: "trolley",
        agencyName: "INA",
        name: "Eureka Springs Trolley System",
        mapx: 645,
        mapy: 295,
        state: true
      },
      {
        id: "nj",
        abbreviation: "nj",
        agencyName: "New Jersey Division of Parks and Forestry",
        name: "New Jersey State Parks",
        mapx: 935,
        mapy: 170,
        state: true
      },
      {
        id: "horse",
        abbreviation: "horse",
        agencyName: "",
        name: "Kentucky Horse Park",
        mapx: 790,
        mapy: 245,
        state: true
      },
      {
        id: "2661",
        abbreviation: "deto",
        agencyName: "National Park Service",
        name: "Devils Tower National Monument",
        mapx: 488,
        mapy: 200,
        state: false
      },
      {
        id: "kilgore",
        abbreviation: "kilgore",
        agencyName: "Maryland Park Service",
        name: "Rocks State Park - Falling Branch/Kilgore Falls Area",
        mapx: 895,
        mapy: 190,
        state: true
      },
      {
        id: "wi",
        abbreviation: "wi",
        agencyName: "Wisconsin Department of Natural Resources",
        name: "Wisconsin State Park System",
        mapx: 680,
        mapy: 110,
        state: true
      },
      {
        id: "aaco",
        abbreviation: "aaco",
        agencyName: "Anne Arundel County",
        name: "Anne Arundel County Recreation & Parks",
        mapx: 900,
        mapy: 208,
        state: false,
        agency: true
      }
    ];
  }
}
